import React from 'react';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import {
  Tab, TabList, TabPanel, TabPanels, Tabs,
} from '@chakra-ui/react';
import useProposals from '../hooks/useProposals';
import useProposalsArchived from '../hooks/useProposalsArchived';
import ProposalsGrid from '../shared/ProposalsGrid';
import ArchivedProposalsSection from '../shared/ArchivedProposalsSection';

// item 485 — Active / Archived tabs (Chad): archive punts a proposal to its own area;
// void stays in the active list with a VOID badge.
const ProposalsPage: React.FC = () => {
  const { data, status } = useProposals();
  const { archived } = useProposalsArchived();
  return (
    <Tabs variant="soft-rounded" colorScheme="brandGreen" isLazy>
      <TabList mb={2}>
        <Tab>Active</Tab>
        <Tab>{`Archived (${archived.length})`}</Tab>
      </TabList>
      <TabPanels>
        <TabPanel px={0}>
          <ProposalsGrid data={data?.index} status={status} />
        </TabPanel>
        <TabPanel px={0}>
          <ArchivedProposalsSection />
        </TabPanel>
      </TabPanels>
    </Tabs>
  );
};
export default withAuthenticationRequired(ProposalsPage);
